import { render, staticRenderFns } from "./ProcessRiskAnalysis.vue?vue&type=template&id=5da2f8de&scoped=true"
import script from "./ProcessRiskAnalysis.vue?vue&type=script&lang=js"
export * from "./ProcessRiskAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProcessRiskAnalysis.vue?vue&type=style&index=0&id=5da2f8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2f8de",
  null
  
)

export default component.exports